var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.playState === _vm.PLAY_STATE.PAUSED)?_c('div',{staticClass:"play-background"},[_c('div',{staticClass:"play-button"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }